export const getFormattedWaste = (value = 0) => {
  return parseFloat(value.toFixed(2));
};

export const getFormattedShare = (value) => {
  return parseFloat((value * 100).toFixed(2));
};
